/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Category_AcInputs */

const he_home_category_ac = /** @type {(inputs: Home_Category_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מזגנים`)
};

const en_home_category_ac = /** @type {(inputs: Home_Category_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Air Conditioners`)
};

/**
* | output |
* | --- |
* | "Air Conditioners" |
*
* @param {Home_Category_AcInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_category_ac = /** @type {((inputs?: Home_Category_AcInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Category_AcInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_category_ac(inputs)
	return en_home_category_ac(inputs)
});